export const setCookies = (name: string, value: string, days: number) => {
  setCookie(name, value, days);
};

export const getCookie = (name: string) => {
  const v = document.cookie.match(`(^|;) ?${name}=([^;]*)(;|$)`);
  return v ? v[2] : null;
};

export const deleteCookie = (name: string) => {
  setCookie(name, '', -1);
};

function setCookie(name: string, value: string, days: number) {
  const d = new Date();
  d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
  document.cookie = `${name}=${value};path=/;expires=${d.toUTCString()}`;
}
